import React from 'react';
import TrainAI from '../../components/TrainAI';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function TrainAIPage() {
  return (
    <PageLayout title="Treinar IA" subtitle="Contexto da marca" primary={<TrainAI />} secondary={null} />
  );
}

export default TrainAIPage;
